export default "__VITE_ASSET__affafc1a__"